const SAFE_LABEL=/^[A-Za-z0-9_.:-]{1,120}$/;

function boundedText(value,max=120){
  const text=String(value??'').trim();
  return text?text.slice(0,max):null;
}

function safeLabel(value,max=120){
  const text=boundedText(value,max);
  return text&&SAFE_LABEL.test(text)?text:null;
}

function safeCorrelation(value){
  const text=String(value??'').trim();
  return /^(?:flow|live|corr)_[A-Za-z0-9_.:-]{1,74}$/.test(text)?text:null;
}

function safeDuration(value){
  const number=Number(value);
  return Number.isFinite(number)&&number>=0?Math.round(number):null;
}

function safeEntry(raw){
  if(!raw||typeof raw!=='object')return null;
  return Object.freeze({
    at:boundedText(raw.at??raw.timestamp,80),
    severity:safeLabel(raw.severity,20),
    module:safeLabel(raw.module??raw.scope,80),
    component:safeLabel(raw.component,80),
    event_code:safeLabel(raw.event_code??raw.code,120),
    outcome:safeLabel(raw.outcome,40),
    duration_ms:safeDuration(raw.duration_ms),
    correlation_id:safeCorrelation(raw.correlation_id),
    flow_id:safeCorrelation(raw.flow_id),
    network_state:safeLabel(raw.network_state,40),
    sync_state:safeLabel(raw.sync_state,40),
    code:safeLabel(raw.code,120)
  });
}

function frozenClone(value){
  return Object.freeze(JSON.parse(JSON.stringify(value)));
}

export function createDiagnosticBundleProvider({
  diagnostics,
  context=()=>({}),
  maxEntries=20,
  now=()=>new Date().toISOString()
}={}){
  if(typeof diagnostics?.exportSafe!=='function')throw new TypeError('diagnostics.exportSafe() is required');
  if(typeof context!=='function')throw new TypeError('context must be a function');
  const limit=Math.min(60,Math.max(1,Number.parseInt(maxEntries,10)||20));

  function create({correlationId=null,screen=null,module=null}={}){
    const exported=diagnostics.exportSafe()??{};
    const details=context()??{};
    const entries=(Array.isArray(exported.entries)?exported.entries:[])
      .slice(-limit)
      .map(safeEntry)
      .filter(Boolean);
    const latest=entries.at(-1)??{};
    const latestRaw=Array.isArray(exported.entries)&&exported.entries.length
      ?exported.entries.at(-1)??{}
      :{};

    return frozenClone({
      schema_version:1,
      generated_at:String(exported.generated_at||now()).slice(0,80),
      app_version:safeLabel(details.appVersion??details.app_version??latestRaw.app_version??latestRaw.version,80)??'unknown',
      app_build:safeLabel(details.appBuild??details.app_build??latestRaw.app_build,80)??'unknown',
      platform:safeLabel(details.platform??latestRaw.platform,40)??'unknown',
      runtime:safeLabel(details.runtime??latestRaw.runtime,40)??'unknown',
      device_class:safeLabel(details.deviceClass??details.device_class,40),
      context:{
        screen:safeLabel(screen??details.screen,120),
        module:safeLabel(module??details.module,120),
        correlation_id:safeCorrelation(correlationId??details.correlationId??latest.correlation_id),
        network_state:safeLabel(details.networkState??details.network_state??latest.network_state,40)??'unknown',
        sync_state:safeLabel(details.syncState??details.sync_state??latest.sync_state,40)??'unknown'
      },
      entries
    });
  }

  return Object.freeze({create});
}
